const mock = ({ documento = {} }) => {
  return {
    tipoComplemento:
      documento?.NaturezaOperacao?.operacao === 'ENTRADA'
        ? 'FORNECEDOR'
        : 'CLIENTE',
    showEntidade: documento?.Especie?.entidade !== 'NAO',
    showLocalEstoque:
      documento?.Especie?.descricao === 'INVENTARIO' ||
      documento?.Especie?.descricao === 'MOVIMENTAÇÃO DE ESTOQUE' ||
      documento?.Especie?.natureza === 'COMPRA' ||
      documento?.Especie?.natureza === 'VENDA' ||
      documento?.Especie?.natureza === 'FATURA' ||
      documento?.NaturezaOperacao?.natureza === 'SERVICOS',
    showContribuinte: documento?.Especie?.natureza !== 'SERVICO',
    isEntrada: documento?.Especie?.grupo === 'ENTRADA',
    isPedido: documento?.especie_id === 4,
    isFatura: documento?.Especie?.natureza === 'FATURA',
  };
};

export default mock;
